import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import createPersistedState from 'vuex-persistedstate'
import { event } from 'vue-analytics'
Vue.use(Vuex)


const metsanomistajaModule = {
  namespaced: true,
  state: {
    stage: 'intro',
    questions: [],
    currentAnswers: [],
    currentQuestion: 1,
    profiles: []
  },
  mutations: {
    FETCH(state, data) {
      state.questions = data.questions;
      state.profiles = data.profiles;
    },
    CHANGE_STAGE(state, newstage) {
      state.stage = newstage;
    },
    NEXT_QUESTION(state) {
      state.currentQuestion = state.currentQuestion + 1;
    },
    ADD_POINTS(state, points) {
      state.currentPoints = state.currentPoints + points;
    },
    ADD_ANSWER(state, answer) {
      let a = state.currentAnswers.find(function (element) { return element.question.id === answer.question.id });
      if (a) {
        state.currentAnswers.splice(state.currentAnswers.lastIndexOf(a), 1, answer);
      } else {
        state.currentAnswers.push(answer);
      }
    },
    RESET(state) {
      state.currentAnswers = [];
      state.currentQuestion = 1;
    }
  },
  actions: {
    fetchQuestions({ commit }) {
      return axios.get('metsanomistaja.json')
        .then(response => commit('FETCH', response.data))
        .catch();
    },

    resetQuiz({ commit }, params) {
      params.router.push('/metsanomistaja');
    },

    startQuiz({ commit, state }, params) {
      commit('RESET');
      params.router.push('/metsanomistaja/kysymykset');
    },
    nextQuestion({ commit }) {
      commit('NEXT_QUESTION');
    },
    showResults({ commit }, params) {
      params.router.push('/metsanomistaja/tulos');
    },
    addPoints({ commit }, points) {
      commit('ADD_POINTS', points);
    },
    addAnswer({ commit }, answer) {
      commit('ADD_ANSWER', answer);
    }
  }
}

const metsankayttajaModule = {
  namespaced: true,
  state: {
    dataReady: false,
    quizStarted: false,
    currentQuestion: 1,
    answers: {
      1: undefined,
      2: 50,
      3: undefined,
      4: 50,
      5: undefined,
      6: 50,
      7: 50,
      8: undefined,
      9: 50,
    },
    profiles: {},
    currentAnswers: [],
    disableButtons: false,
    questions: {

    },
    points: {
      legs: [],
      torso: [],
      head: [],
    },
    results: {
      profile: '',
      description: '',
      image: '',
    },
    profileCalculated: false,
    shortname: {
      "Metsäseikkailija": 's',
      "Nautiskelija": 'n',
      "Tuleva metsänomistaja": 'a'
    }
  },
  mutations: {
    FETCH(state, data) {
      state.questions = data.questions;
      state.profiles = data.profiles;
      state.dataReady = true;
    },

    NEXT_QUESTION(state) {
      state.currentQuestion = state.currentQuestion + 1;
    },

    PREVIOUS_QUESTION(state) {
      state.currentQuestion = state.currentQuestion - 1;
    },

    ADD_POINTS(state, payload) {
      state.points[payload.part].push(payload.answer);
    },

    ADD_ANSWER(state, payload) {
      state.answers[payload.question] = payload.answer/*
      let a = state.currentAnswers.find(function(element) { return element.question.id === payload.question.id });
      if(a) {
        state.currentAnswers.splice(state.currentAnswers.lastIndexOf(a), 1, payload);
      } else {
        state.currentAnswers.push(payload);
      }*/
    },

    RESET(state) {
      state.profileCalculated = false;
      state.currentAnswers = [];
      state.currentQuestion = 1;
      state.quizStarted = false;
      state.disableButtons = false;
      state.latestProfiles = [];
      state.answers = {
        1: undefined,
        2: 50,
        3: undefined,
        4: 50,
        5: undefined,
        6: 50,
        7: 50,
        8: undefined,
        9: 50,
      }
    },

    START(state) {
      state.quizStarted = true;
    },

    STOP(state) {
      state.quizStarted = false;
    },

    CHANGE_PROFILE(state, payload) {
      state.results = payload;
      state.profileCalculated = true;
    },

    UPDATE_ANSWER(state, payload) {
      state.answers[state.currentQuestion] = payload;
    },

    FETCH_LATEST_PROFILES(state, payload) {
      state.latestProfiles = payload;
    }
  },
  actions: {
    startQuiz({ commit, state }, params) {
      commit('RESET');
      commit('START');
      params.router.push('/metsankayttaja/kysymys/' + state.currentQuestion);
    },

    fetchQuestions({ commit }) {
      commit('RESET');
      return axios.get('metsankayttaja.json')
        .then(response => commit('FETCH', response.data))
        .catch();
    },

    resetQuiz({ commit }, params) {
      params.router.push('/metsankayttaja');
    },

    previousQuestion({ commit, state }, params) {
      commit('PREVIOUS_QUESTION');
      params.router.push('/metsankayttaja/kysymys/' + state.currentQuestion);
    },

    nextQuestion({ commit, state }, params) {
      commit('NEXT_QUESTION');
      params.router.push('/metsankayttaja/kysymys/' + state.currentQuestion);
    },

    showResults({ commit }, params) {
      commit('STOP');
      params.router.push('/metsankayttaja/tulos');
    },

    addPoints({ commit }, payload) {
      commit('ADD_POINTS', payload)
    },

    addAnswer({ commit }, payload) {
      commit('ADD_ANSWER', payload);
    },

    fetchLatestProfiles({ state, commit }) {
      axios.get('http://metsankayttaja.plab.fi/backend/HelloAnalytics.php')
        .then(function (resp) {

          let split2 = function split2(str, separator, limit) {
            if (limit == 0) return [str];
            var a = str.split(separator, limit);
            if (a.length == limit) {
              let s = a.join(separator) + separator;
              a.push(str.substr(s.length));
              return a;
            } else {
              return [str];
            }
          }

          let descriptions = [];
          let images = [];
          let profiles = [];
          const daattor = resp.data.map(item => split2(item[1], " ", 2))

          let getKeyByValue = function getKeyByValue(object, value) {
            return Object.keys(object).find(key => object[key] === value);
          }

          for(let i = 0; i < 5; i++) {

              descriptions.push(
                state.profiles.description[daattor[i][0]] + ' ' +
                state.profiles.description[daattor[i][1]] + ' ' +
                state.profiles.description[daattor[i][2]]
              )

              images.push(
                state.shortname[getKeyByValue(state.profiles.name.legs, daattor[i][0])] + '-' + state.shortname[getKeyByValue(state.profiles.name.torso, daattor[i][1])] + '-' + state.shortname[getKeyByValue(state.profiles.name.head, daattor[i][2])] + '.png'
              )

              const profilename = daattor[i][0] + " " + daattor[i][1] + " " + daattor[i][2]
              profiles.push({ 
                profile: profilename, 
                description:
                  state.profiles.description[daattor[i][0]] + ' ' +
                  state.profiles.description[daattor[i][1]] + ' ' +
                  state.profiles.description[daattor[i][2]],
                image:
                  state.shortname[getKeyByValue(state.profiles.name.legs, daattor[i][0])] + '-' + state.shortname[getKeyByValue(state.profiles.name.torso, daattor[i][1])] + '-' + state.shortname[getKeyByValue(state.profiles.name.head, daattor[i][2])] + '.png'
              })
          }
      
          commit('FETCH_LATEST_PROFILES', profiles);
        })
    },

    getProfile({ commit, state }) {
      let profilePoints = {
        legs: {},
        torso: {},
        head: {}
      };

      for (let i = 1; i <= 9; i++) {
        let question = state.questions.find((q) => q.id === i);
        let answer = question.answers.find((a) => a.id === state.answers[i]);



        if (question.type === 'slider') {
          if (state.answers[i] < 33) {
            answer = question.answers.find((a) => a.id === 1);
          } else if (state.answers[i] >= 66) {
            answer = question.answers.find((a) => a.id === 3);
          } else {
            answer = question.answers.find((a) => a.id === 2);
          }
        }


        event({
          eventCategory: 'Question',
          eventAction: question.question,
          eventLabel: answer.text,
          eventValue: 1
        })

        profilePoints[question.part][answer.profile] = profilePoints[question.part][answer.profile] + answer.points || 0 + answer.points;
      }

      let legsProfile = null;
      for (var key in profilePoints.legs) {
        if (profilePoints.legs.hasOwnProperty(key)) {
          legsProfile = key;
        }
      }
      //let legs = 'img/osat/' + state.profiles.images.legs[legsProfile];

      let torsoProfile = null;
      for (var key2 in profilePoints.torso) {
        if (profilePoints.torso.hasOwnProperty(key2)) {
          torsoProfile = key2;
        }
      }

      //let torso = 'img/osat/' + state.profiles.images.torso[torsoProfile];

      let headProfile = null;
      for (var key3 in profilePoints.head) {
        if (profilePoints.head.hasOwnProperty(key3)) {
          headProfile = key3;
        }
      }

      //let head = 'img/osat/' + state.profiles.images.head[headProfile];


      let profile = state.profiles.name.legs[legsProfile] + ' ' + state.profiles.name.torso[torsoProfile] + ' ' + state.profiles.name.head[headProfile];
      let description = state.profiles.description[state.profiles.name.legs[legsProfile]] + ' ' + state.profiles.description[state.profiles.name.torso[torsoProfile]] + ' ' + state.profiles.description[state.profiles.name.head[headProfile]];


      // Determine facebook share image
      state.shortname = {
        "Metsäseikkailija": 's',
        "Nautiskelija": 'n',
        "Tuleva metsänomistaja": 'a'
      }

      let image = state.shortname[headProfile] + '-' + state.shortname[torsoProfile] + '-' + state.shortname[legsProfile] + '.png';

      // Vue analytics
      event({
        eventCategory: 'Quiz',
        eventAction: 'Completed',
        eventLabel: profile,
        eventValue: 1
      })


      commit('CHANGE_PROFILE', { profile, description, image })
    },
  },
  getters: {
    qid: (state) => (id) => {
      return state.questions.find(q => q.id === id)
    }
  }
}

export default new Vuex.Store({
  modules: {
    metsanomistaja: metsanomistajaModule,
    metsankayttaja: metsankayttajaModule
  },

  plugins: [createPersistedState()]
})

export const actions = metsankayttajaModule.actions
